import { gql } from "@apollo/client";

const USERS = gql`
  query users {
    users {
      id
      name
      email
    }
  }
`;

export default USERS;
